export default __webpack_public_path__ + "maps-guides-markers-annotations-view-960-6a6df293dfc7872786240b6cc8267dfb.png";